// extracted by mini-css-extract-plugin
export default {"form":"UpdateUserModal_form__66GJW","submitButton":"UpdateUserModal_submitButton__OqzIU"};